export const strainPrompt = (strainName) => {
    return `You are a cannabis content writer tasked with creating a full-length, SEO-optimized article for a cannabis THCa flower strain. Your goal is to rank highly for THCa-related keywords, educate readers about THCa, and convert them into customers through engaging, trustworthy content.

I will provide only the strain name. You must conduct thorough research using reliable sources (Leafly, Weedmaps, verified scientific articles, breeder websites, etc.) and do not fabricate anything. Leave out any unconfirmed info.

Tone: Friendly, informative, and entertaining. Combine real cannabis science with smart commentary and a touch of humor. Write for curious, well-informed buyers who want the best of both THC and THCa experiences.

Your Output Must Include:

Meta Title:
Max 60 characters


Include the phrase “THCa Flower” and the strain name + brief hook + CTA (e.g., “Buy now,” “Available online”)



Meta Description:
Max 160 characters


Include “THCa Flower,” strain name, brief effect or flavor hook + CTA (e.g., “Shop Blackberry THCa flower now”)



Intriguing H2:
Avoid generic strain names. Use a clickable headline that teases Blackberry’s unique qualities as THCa flower



Body Structure:
Intro Paragraph: Explain why THCa flower is trending, and why this strain is a top pick


H2: What is ${strainName} (THCa Flower)?


Include product classification, effect profile, and THCa-specific info


H2: Benefits of THCa Flower


Brief overview of what THCa is, why people prefer it (non-psychoactive until heated, legal gray area, high potency when smoked, etc.)


H2: Effects of ${strainName}


H2: Flavors and Aromas


H2: Lineage and Genetics


H2: Medical Uses


H2: Similar THCa Flower Strains


H2: Final Thoughts



Word Count: 1,000–1,200 words

SEO Goals:
Target primary keyword: “THCa Flower”


Secondary keywords: “${strainName} THCa,” “Buy THCa flower online,” “${strainName} effects,” etc.


Use formatting and headers to boost scannability and SEO.



Conversion Reminder:
Mention that THCa flower is available for purchase or delivery


Include soft CTAs like “Shop Blackberry THCa Flower online today” or “Explore legal THCa flower options”

    `
}



export const productTypesPrompt = {

    flower: (data) =>
        `Consider yourself a cannabis expert with a 20 years of experience in writing accurate information about cannabis flower and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized product description for a cannabis flower ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Flower
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product Overview  (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Aroma and Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects and Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. THC Content & Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName}+ + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (flower in this case) + effects/flavor + CTA (e.g., "Order now," "Explore ${data?.categoryName} Deals")
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Research the flavor, effects, and parent genetics.
2. Use keywords like "premium cannabis flower," "THC content," and "${data?.StrainType} strain" not randomly and not all of them but based on the categories provided above and the strain of the product.
3. Tone: Cool, witty, stoner-friendly.
4. Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.\ `
    ,
    concentrates: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis concentrate and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis concentrate ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Concentrate
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product & Type (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Flavor & Aroma (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Potency, Effects & Experience (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Usage Notes (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} (Product Name) + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} (Product Name) + ${data?.BrandName} (Brand Name), product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Include the type of concentrate; in this case it is ${data?.categoryName}, the strain (in this case it is ${data?.StrainType}), and the parent genetics.
2. Use SEO terms like ${data?.StrainType} live resin” or “THC concentrate” not randomly and not all of them but based on the category of the product. It is strict to use keywords related to the category of the product.
3. Keep the tone high-level but relatable for dab users.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES
    .\
              `
    , edibles: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis edibles and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis edible ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Edibles
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Overview & Dosing (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Flavor & Texture (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Onset, Effects & Best Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Cannabinoid Content & Warnings (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Mention flavor, dosage per piece, total THC, and number of pieces.
2. Include keywords like "THC gummies," "cannabis-infused chocolate," and "edibles for sleep," not randomly and not all of them but based on the categories provided above and the strain of the product. The keywords must include the actual categories and strains of the product
3. Keep the tone snack-friendly and stoner-aware.
4. Restricted words: Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.\
      ` ,
    vapes: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about vapes and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a vape product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Vape
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product & Format (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Strain, Flavor & Draw (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Potency & On-the-Go Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Compatibility or Tech Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Include format (disposable, 510 thread, pod, etc.) and oil type not randomly and not all of them but based on the category of the product. It is strict to use keywords related to the category of the product.
2. Use keywords: “${data?.StrainType} vape cart,” “THC vape pen,” “cannabis oil cartridge” not randomly and not all of them but based on the category of the product.
3. Keep the tone chill, casual tone with clarity but relatable for vape users.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES\.`,

    wellness: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis wellness products and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a wellness product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Wellness
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:

1. Product Overview & Use Case (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Cannabinoid Content & Application Method (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

3. Effects & Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

4. Recommended Use & Audience (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Mention use cases (sleep, focus, pain relief, stress, etc.) not randomly and not all of them but based on the category and strain of the product. It is strict to use use cases related to the category and strain of the product.
2. Keywords: “CBD tincture,” “THC patch,” “cannabis balm,” “CBN capsules.” not randomly and not all of them but based on the category and strain of the product.
3. Keep the tone wellness-friendly but casual tone.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.
  `,
    accessories: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis accessory products and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a accessory product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Accessory
4. THC Content: No because the product is non-cannabis
5. Strain: No because the product is non-cannabis
6. Weight of the Product: Not applicable becuase the product is non cannabis

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:

1. Product Overview & Purpose (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Design & Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. How It Enhances the Session (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Who It’s For (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Mention use cases not randomly but based on the category of the product. It is strict to use use cases related to the category of the product.
2. Keywords: “rolling tray,” “weed pipe,” “grinder,” “stash container” not randomly and not all of them but based on the category and strain of the product.
3. Keep the tone fun, clever tone — show personality.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES .
  `,
    prerolls: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis pre-rolls and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis pre-roll product, ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Pre Rolls
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Overview (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Strain Info & Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects & Session Type (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Standout Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Mention weight per joint (e.g., 1g, 0.5g), pack size, and infusion type if used.
2. Include keywords: “infused pre-roll,” “1g joint,” “pre-roll pack,” “[strain name] pre-roll,” not randomly and not all of them but based on the categories provided above and the strain of the product. The keywords must include the actual categories and strains of the product
3. Keep the tone smoke-smart and stoner-approved.
4. Restricted words: Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.
  `
}
/**
 * Brand page content generator prompt.
 *
 * REQUIRES the web_search tool to be attached to the API call.
 *
 * Backwards compatible. Existing calls still work:
 *   buildBrandMetaPrompt({ brandName, heading, shortDescription, bottomDescription })
 *
 * NEW optional field:
 *   brandWebsiteUrl - pass the Brand Website URL already stored in the CMS.
 *   Brand names like "1904" cannot be found by search alone. The URL fixes that.
 *
 * NEW output field: FAQ
 *   The prompt now returns FAQs. Your CMS has FAQ boxes that are currently
 *   empty because the old prompt never generated them. Your dev must parse
 *   the FAQ block and map it to those boxes. If you do not want FAQs yet,
 *   delete the FAQ section from the output list and the field spec below.
 */
export const buildBrandMetaPrompt = ({
    brandName,
    heading,
    shortDescription,
    bottomDescription,
    brandWebsiteUrl = null,
}) => {
    const safe = (v) => String(v ?? "").trim();

    const safeBrandName = safe(brandName) || "Not provided";
    const safeHeading = safe(heading) || "Not provided";
    const safeShortDescription = safe(shortDescription) || "Not provided";
    const safeBottomDescription = safe(bottomDescription) || "Not provided";
    const safeWebsiteUrl = safe(brandWebsiteUrl);

    const websiteBlock = safeWebsiteUrl
        ? `OFFICIAL BRAND WEBSITE: ${safeWebsiteUrl}

Read this website FIRST, before any other search. It is the most reliable source for this brand. Pull the real product categories, the brand story, the founding details, the growing or extraction approach, and the regional identity from it. Everything you take from this site counts as verified.`
        : `OFFICIAL BRAND WEBSITE: not supplied.

Search for the brand's official website yourself before using third party sources. If the brand name is a common word, a number, or a year, add words like "cannabis brand California" to your search so you do not pull unrelated results.`;

    const promptTemplate = `You are a cannabis SEO copywriter writing a brand collection page for Hyperwolf, a licensed California cannabis delivery service. The reader is an adult aged 21 or over deciding whether to order this brand today.

BRAND: ${safeBrandName}

${websiteBlock}

=====================================================================
STEP 1: RESEARCH FIRST
=====================================================================

You have a web search tool. Use it before writing anything.

Sources to check, in this order:
1. The official brand website
2. Weedmaps and Leafly brand pages
3. Licensed dispensary and delivery menus carrying the brand
4. Press coverage and trade publications

Find, where possible:
- What the brand actually makes, by category
- When and where it started, and who runs it
- Its growing method, extraction method, or genetics focus
- Where in California it operates
- What it is genuinely known for, in the words of retailers and reviewers
- Any collaborations, awards, or signature products

Search efficiently. Three to five searches is normally enough.

=====================================================================
STEP 2: THE VERIFICATION RULE
=====================================================================

This is the most important rule on the page. The previous version of this
page told readers that information about the brand was limited. Never do that.

For every fact, judge your evidence:

- Confirmed by the brand site, or by two other sources: state it plainly. No hedging.
- One source only: state it once with a light qualifier.
- Not found: DO NOT WRITE ABOUT IT. Skip the section. Do not write a paragraph explaining that the information is limited, unclear, not well documented, or not publicly available. Do not write a section heading and then fill it with an apology for having nothing to say. Just leave it out.

Never guess product categories. If research does not confirm what the brand
makes, omit the Product Categories section entirely. A shorter page that is
true beats a longer page that guesses.

Never write filler about the California cannabis market, licensing in general,
lab testing in general, or how delivery works in general, in place of facts
about this brand. That is padding.

=====================================================================
STEP 3: PAGE LENGTH DEPENDS ON WHAT YOU FOUND
=====================================================================

Do not pad to hit a word count. Choose the tier that matches your research:

- Strong research, brand site read, categories and story confirmed:
  BOTTOM_TEXT is 700 to 900 words.
- Some research, a few facts confirmed:
  BOTTOM_TEXT is 400 to 600 words.
- Very little confirmed:
  BOTTOM_TEXT is 250 to 350 words. Write only the About section, kept short
  and factual, and the How to Shop section. Nothing else.

A 300 word accurate page is a success. A 1200 word vague page is a failure.

=====================================================================
STEP 4: HARD RULES
=====================================================================

COMPLIANCE
- The regulator is the California Department of Cannabis Control, or DCC.
  NEVER write "Bureau of Cannabis Control". That agency was replaced and no
  longer exists.
- Do not guarantee that every product has passed testing, is compliant, is in
  stock, or is safe. You may say that products sold through licensed California
  retailers are subject to state testing requirements. Do not turn that into a
  promise about this brand.
- No medical claims. Nothing treats, cures, prevents, relieves, manages or
  diagnoses anything.
- No dosage advice and no consumption amounts.
- No THC or CBD percentages. You have no lab data for this brand. Point the
  reader to the live product listing instead.
- Do not promise prices, stock levels, or delivery times beyond the approved
  delivery wording in the meta fields.
- Written for adults 21 and over.

BRAND NAME
Hyperwolf is written with a lowercase w. Never "HyperWolf", never "Hyper Wolf".

=====================================================================
STEP 5: WRITING STYLE
=====================================================================

Write like a knowledgeable buyer explaining why this brand is on the menu.
Plain, confident, specific. Not a press release.

BANNED PHRASES. Do not use these or close variants:
premium quality, top-tier, best in class, industry-leading, cutting-edge,
craft-forward, meticulously crafted, carefully curated, a name that needs no
introduction, has emerged as, in the modern cannabis marketplace, in today's
cannabis landscape, worth exploring, peace of mind, that peace of mind is a
real part of why, without a lot of guesswork, at the end of the day, when it
comes to, it is worth noting, it is important to note, whether you are new to
cannabis or a seasoned consumer, look no further, here's how the process
generally works, one of the clearest advantages, from the comfort of your own
home, make a smart informed choice, take your session to the next level,
elevate your experience, dive into, unpack, navigate, game-changer.

ALSO BANNED
- Any sentence saying information about the brand is limited, unclear, not well
  documented, or hard to verify.
- Any sentence starting "Rather than speculate".
- Adverb padding: really, truly, simply, genuinely, actually, incredibly,
  notably, particularly, especially, remarkably.
- Rhetorical questions.
- Repeating the same point in more than one section.

NO EM DASHES. Never use the em dash or en dash character in any field. Use a
comma, a full stop, or rewrite the sentence.

NO SEPARATOR LINES. Never output three dashes, three underscores, three
asterisks, or any horizontal rule, at the end of a field or anywhere else.

SPACING
- Exactly one space between every pair of words. Never join two words together.
- Exactly one space after every comma, full stop and colon that is followed by
  more text.
- Never break a line in the middle of a sentence.
- No double spaces, no tab characters, no non-breaking spaces.

=====================================================================
STEP 6: OUTPUT
=====================================================================

Return only these fields, in this exact order, with these exact labels.
No preamble, no commentary, no citations, no markdown, no code fences.

TITLE:

DESCRIPTION:

META_TITLE:

META_DESCRIPTION:

SHORT_DESCRIPTION:

BOTTOM_TEXT:

FAQ:

ALT_TEXT:

--- FIELD SPECIFICATIONS ---

TITLE
The page H1. Three to seven words. Must contain the brand name.
Style: ${safeBrandName} Cannabis Products
Natural, not keyword stuffed.

DESCRIPTION
70 to 120 words for the top of the page. Say what the brand actually makes and
what it is known for, based on research. Name product categories only if
verified. Mention shopping from Hyperwolf once, naturally. No fluff.

META_TITLE
Use this approved format. Do not invent a different one.
Buy ${safeBrandName} from Hyperwolf | 60-Min Weed Delivery
Target 45 to 60 characters. Maximum 60.
If the brand name makes it too long, use this fallback:
Buy ${safeBrandName} at Hyperwolf | Weed Delivery
Include the exact brand name. Include Hyperwolf. Keep the pipe with a space on
both sides. Do not add other keywords.

META_DESCRIPTION
Use this approved format. Do not invent a different one.
Shop ${safeBrandName} products online. Buy from Hyperwolf with 60-minute weed delivery or scheduled delivery in California.
Target 140 to 160 characters. Maximum 160.
Include the exact brand name, Hyperwolf, 60-minute weed delivery, and scheduled
delivery in California. If the brand name is long, shorten naturally while
keeping those elements.

SHORT_DESCRIPTION
40 to 70 words. The brand's identity, what it focuses on, and why a shopper
would pick it. Must not repeat sentences from DESCRIPTION. End naturally with
purchase intent. No separator line at the end.

BOTTOM_TEXT
Valid HTML only. No markdown.
Length per the tier rules in Step 3.

Allowed tags: <h2>, <h3>, <p>, <ul>, <li>, <strong>
Banned tags: <h1>, <h4>, <h5>, <h6>, <br>, <br/>, <div>, <span>, tables, code
fences, empty tags, links, style or class attributes.

DO NOT PUT <br/> ANYWHERE. Not between paragraphs, not between list items, not
at the end of a section. It creates empty bullet points in the editor.

Structure rules:
- First heading is an <h2>. Never an <h1>.
- Every heading is followed by at least one full <p>.
- Never two headings in a row.
- Most copy sits in <p> tags, not headings.
- Introduce every <ul> with a short <p> first.
- Paragraphs run 2 to 4 sentences.
- Write each tag pair on its own line, with content directly inside the tag and
  no leading or trailing space, like <p>Text here.</p>

SECTIONS. Include a section ONLY if research supports it. Skip any section you
cannot fill with real information. Keep this order:

<h2>About ${safeBrandName}</h2>
Required. Who they are, where they operate, what they make. If research was
thin, keep this to one short paragraph and move on.

<h2>What ${safeBrandName} Is Known For</h2>
Include only if you found something specific and true. A signature product, a
reputation, a method, a following. Skip entirely if you did not.

<h2>Product Categories from ${safeBrandName}</h2>
Include ONLY if research confirms the actual categories this brand sells.
List the real ones in a <ul>. Never list categories the brand may or may not
make. Never write "products may include". Skip the whole section if unverified.

<h2>Flavor, Genetics, or Extraction Style</h2>
Include only if the brand has a documented approach worth describing.

<h2>Why Shoppers Choose ${safeBrandName}</h2>
Include only if you can name something specific to this brand. Not generic
statements about licensed delivery or regulated supply chains. Skip if you
cannot make it brand specific.

<h2>How to Shop ${safeBrandName} Online at Hyperwolf</h2>
Required. Always last. One or two short paragraphs. Tell the reader to browse
the brand on the Hyperwolf menu, check the live product listing for format and
batch details, and note that a valid ID showing age 21 or over is required at
delivery. Keep it brief. Do not write a numbered walkthrough of the checkout
process.

Do not write a Final Thoughts or conclusion section. The page ends after the
shopping section.

Use these phrases naturally across the page, not repeatedly:
${safeBrandName} cannabis, buy ${safeBrandName} online, ${safeBrandName} delivery, shop ${safeBrandName} at Hyperwolf

FAQ
Exactly 4 question and answer pairs, in this format, with a blank line between
pairs:

FAQ:
[Question 1]
What products does ${safeBrandName} make?
[Answer 1]
Your real answer here.

[Question 2]
Your real question here.
[Answer 2]
Your real answer here.

Continue through [Question 4] and [Answer 4].

Cover these four topics in this order:
1. What products does ${safeBrandName} make?
2. What is ${safeBrandName} known for?
3. Where can I buy ${safeBrandName} in California?
4. Can I get ${safeBrandName} delivered?

FAQ rules:
- Each answer is 40 to 75 words.
- Plain text only. No HTML, no markdown, no bullets, no "Q:" or "A:".
- Answer the question in the first sentence, then support it.
- Do not copy sentences from BOTTOM_TEXT.
- If research did not confirm what the brand makes, answer question 1 by
  telling the reader to check the live Hyperwolf menu for current listings.
  Do not guess and do not say information is limited.
- Question 4 may reference 60-minute or scheduled delivery in California.
  Do not promise a delivery time for a specific order.

ALT_TEXT
Six to twelve words. Under 90 characters.
You cannot see the image, so describe the most likely subject plainly: brand
packaging or product on display. Include the brand name.
Do not start with "Image of" or "Picture of". No promotional wording.
Good: ${safeBrandName} cannabis product packaging on display
Bad: Buy ${safeBrandName} weed online at Hyperwolf with fast delivery

=====================================================================
FINAL CHECK BEFORE OUTPUT
=====================================================================

1. No em dash or en dash anywhere.
2. No two words joined without a space.
3. No <br/> anywhere.
4. No three-dash or other separator line at the end of any field.
5. No sentence saying brand information is limited or unclear.
6. No guessed product categories.
7. No THC or CBD numbers.
8. "Department of Cannabis Control", never "Bureau of Cannabis Control".
9. Hyperwolf spelled with a lowercase w every time.
10. No banned phrase from the list.
11. No Final Thoughts section.
12. Length matches the research tier, and nothing was padded to reach it.

Output the fields only.

=====================================================================
EXISTING CMS CONTENT FOR THIS BRAND
=====================================================================
Use this only as background context. Do not copy it. If it contains errors,
vagueness, or claims your research does not support, replace it.

HEADING: ${safeHeading}
SHORT_DESCRIPTION_INPUT: ${safeShortDescription}
BOTTOM_DESCRIPTION_INPUT: ${safeBottomDescription}`;

    return promptTemplate;
};

// export const buildBrandMetaPrompt = ({
//     brandName,
//     heading,
//     shortDescription,
//     bottomDescription,
// }) => {
//     const safe = (v) => String(v ?? "").trim();

//     const safeBrandName = safe(brandName) || "Not provided";
//     const safeHeading = safe(heading) || "Not provided";
//     const safeShortDescription = safe(shortDescription) || "Not provided";
//     const safeBottomDescription = safe(bottomDescription) || "Not provided";
//     const promptTemplate = `You are a cannabis brand storyteller and SEO copywriter creating high-quality, conversion-focused content for a cannabis BRAND page on Hyperwolf.

// I will provide only the BRAND NAME.

// Your job is to research the brand using reliable sources such as:
// - Official brand websites
// - Licensed dispensary listings
// - Leafly
// - Weedmaps
// - Headset market reports
// - Press releases
// - Reputable retailer or menu pages

// Do not fabricate facts. Do not invent founding dates, regions, awards, product categories, or brand claims. If verified information is limited, stay factual and lean into what can be safely said about the brand's product range, style, positioning, and consumer appeal.

// Write for well-informed cannabis shoppers in California.

// Tone should be:
// - Friendly
// - Trustworthy
// - Conversational
// - Informed
// - Non-generic
// - Never slangy or exaggerated

// Very Important Rules
// - Avoid generic filler like "premium quality," "top-tier," "best in class," or "industry-leading" unless clearly supported by research.
// - Do not keyword-stuff.
// - Do not make medical claims.
// - Do not use hypey language that sounds templated or AI-generated.
// - Keep the writing natural, specific, and brand-aware.
// - Mention Hyperwolf naturally where relevant for delivery/purchase intent.
// - Prioritize clarity, authenticity, and SEO value.

// Output exactly in this structure:

// TITLE:
// Write a clean page title/H1 for the brand collection page.

// Requirements:
// - 3 to 7 words preferred
// - Include the brand name
// - Natural for users, not stuffed
// - Example style: Alien Labs Cannabis Products

// DESCRIPTION:
// Write a concise supporting description for the top of the page.

// Requirements:
// - Around 70 to 120 words
// - Summarize what the brand is known for
// - Mention key product categories only if verified
// - Mention shopping from Hyperwolf naturally
// - No fluff, no repeated phrases

// META_TITLE:
// Use this format as the default pattern:
// Buy [BRAND NAME] from Hyperwolf | 60-Min Weed Delivery
// Meta Title: (Max 60 characters) Should include ${brandName} (Brand Name) + Hyperwolf + a concise delivery hook.

// Rules:
// - Keep the structure very close to this format
// - Include the exact brand name
// - Include "Hyperwolf"
// - Include "60-Min Weed Delivery" whenever it fits naturally within the character limit
// - Keep it concise and click-worthy
// - Target roughly 45 to 60 characters
// - Do not add extra product keywords unless absolutely necessary
// - Do not make it sound generic

// Fallback rule:
// If the brand name is too long, shorten carefully while preserving the core structure and intent.
// Acceptable shorter variation:
// Buy [BRAND NAME] at Hyperwolf | Weed Delivery

// META_DESCRIPTION:
// Use this format as the default pattern:
// Shop [BRAND NAME] products online. Buy from Hyperwolf with 60-minute weed delivery or scheduled delivery in California.
// Meta Description: (Max 160 characters) Should include ${brandName} (Brand Name) + Hyperwolf + 60-minute weed delivery + scheduled delivery in California.

// Rules:
// - Keep the structure very close to this format
// - Include the exact brand name
// - Include "Hyperwolf"
// - Include "60-minute weed delivery"
// - Include "scheduled delivery in California"
// - Keep it natural and readable, not robotic
// - Target roughly 140 to 160 characters
// - Do not stuff product types unless it genuinely improves relevance
// - Do not use vague promotional language

// Fallback rule:
// If the brand name is long, shorten naturally while keeping the meaning intact.
// Example fallback:
// Shop [BRAND NAME] online at Hyperwolf. Get 60-minute weed delivery or scheduled delivery in California.

// SHORT_DESCRIPTION:
// Write a short brand summary.

// Requirements:
// - Around 40 to 70 words
// - Mention the brand's identity, product focus, and what makes it appealing
// - Keep it useful and specific
// - End naturally with purchase intent where appropriate
// - Avoid sounding repetitive with the main description

// BOTTOM_TEXT:
// Write a detailed SEO bottom text section for the brand page.

// Critical output rule:
// Return BOTTOM_TEXT as VALID HTML ONLY, not Markdown.

// Word count:
// - Target 1200 to 1500 words

// Allowed HTML tags:
// - <h2>
// - <h3>
// - <p>
// - <ul>
// - <li>
// - <strong>

// Do not use:
// - <h1>
// - <h4>, <h5>, <h6>
// - Markdown headings
// - Markdown bullets
// - tables
// - code fences
// - divs or spans
// - empty tags

// HTML structure rules:
// - The first heading inside BOTTOM_TEXT must be an <h2>, never an <h1>
// - Every major section must start with <h2>
// - Use <h3> only for subsections nested under the relevant <h2>
// - Every heading must be followed by at least one full <p> paragraph
// - Do not place two headings back-to-back unless absolutely necessary
// - Most body copy must be written in <p> tags, not headings
// - Do not turn sentence fragments into headings
// - Use lists only when they improve readability and only for short grouped points
// - Each list must be introduced by a short <p> before the <ul>
// - Keep paragraphs medium length, usually 2 to 5 sentences
// - Keep the HTML clean, readable, and properly nested

// Required section flow for BOTTOM_TEXT:
// 1. <h2>About [BRAND NAME]</h2>
// 2. <h2>What [BRAND NAME] Is Known For</h2>
// 3. <h2>Product Categories from [BRAND NAME]</h2>
// 4. <h2>Flavor, Genetics, or Extraction Style</h2> only if verified
// 5. <h2>Why Shoppers Choose [BRAND NAME]</h2>
// 6. <h2>How to Shop [BRAND NAME] Online at Hyperwolf</h2>
// 7. <h2>Final Thoughts</h2>

// Additional writing rules for BOTTOM_TEXT:
// - Explain what makes the brand interesting to actual shoppers
// - Mention flower, vapes, concentrates, edibles, pre-rolls, or other categories only if verified
// - If a category is not clearly supported by research, do not force it in
// - If the brand has a distinctive cultivation style, extraction approach, genetics focus, collaborations, or regional identity, highlight that
// - Include SEO phrases naturally, such as:
//   - [BRAND NAME] cannabis
//   - buy [BRAND NAME] online
//   - [BRAND NAME] delivery
//   - shop [BRAND NAME] at Hyperwolf
// - Do not repeat the same keyword over and over
// - Avoid writing a generic brand essay that could apply to any cannabis company
// - Keep the writing brand-specific, useful, and natural

// Example formatting pattern for BOTTOM_TEXT:
// <h2>About [BRAND NAME]</h2>
// <p>Paragraph text here.</p>
// <p>Paragraph text here.</p>

// <h2>What [BRAND NAME] Is Known For</h2>
// <p>Paragraph text here.</p>

// <h3>Verified Product Focus</h3>
// <p>Paragraph text here.</p>

// <h2>Product Categories from [BRAND NAME]</h2>
// <p>Paragraph text here.</p>
// <ul>
//   <li>Verified category one</li>
//   <li>Verified category two</li>
// </ul>

// ALT_TEXT:
// Write one SEO-friendly alt text for the primary brand image.

// Requirements:
// - Keep it concise
// - Ideally 6 to 12 words
// - Usually under 90 characters
// - Describe what is actually visible in the image first
// - Include the brand name only when useful
// - If relevant, mention the product type or packaging shown
// - Keep it natural, not stuffed
// - Do not start with "Image of" or "Picture of"
// - Do not write promotional copy
// - Do not over-explain

// Good alt text style examples:
// - Alien Labs cannabis flower jar packaging
// - Alien Labs branded vape packaging on display
// - Alien Labs pre-roll product packaging close-up

// Bad alt text examples:
// - Buy Alien Labs weed products online at Hyperwolf with fast delivery
// - Best premium Alien Labs cannabis brand image for California shoppers
// - Image of Alien Labs weed product packaging and cannabis brand design

// Final quality check before answering:
// - Make sure the meta title matches the Hyperwolf delivery format
// - Make sure the meta description matches the Hyperwolf delivery format
// - Make sure alt text is short, descriptive, and SEO-aware
// - Remove generic filler
// - Remove any unverifiable claims
// - Keep the voice natural and brand-specific
// - Make sure BOTTOM_TEXT is valid HTML
// - Make sure the first heading in BOTTOM_TEXT starts with <h2>
// - Make sure most of the content is in <p> tags, not headings
// - After each paragraph tag, use a <br/> line.

// Return only the following fields in this exact order:

// TITLE:

// DESCRIPTION:

// META_TITLE:

// META_DESCRIPTION:

// SHORT_DESCRIPTION:

// BOTTOM_TEXT:

// ALT_TEXT:

// Input variables to use for this brand:
// - BRAND_NAME: ${safeBrandName}
// - HEADING: ${safeHeading}
// - SHORT_DESCRIPTION_INPUT: ${safeShortDescription}
// - BOTTOM_DESCRIPTION_INPUT: ${safeBottomDescription}`;

//     return promptTemplate.replaceAll("[BRAND NAME]", safeBrandName);
// };

export const buildBannerAltPrompt = ({ brandName, heading, imageName }) => {
    const safe = (v) => String(v ?? "").trim();
    return `You are an accessibility expert. Generate one concise banner image alt text for a cannabis brand website.

Brand Name: ${safe(brandName)}
Brand Heading: ${safe(heading)}
Banner Image File Name: ${safe(imageName)}

Rules:
- Return only one plain-text sentence.
- Maximum 125 characters.
- Maximum 10 words.
- Be specific and descriptive.
- Do not include labels, markdown, quotes, or extra explanation.`;
};

export const buildProductMetaPrompt = ({
    productName,
    brandName,
    categoryName,
    thcValue,
    thcUnit,
    strainType,
    weightValue,
    weightUnit,
}) => {
    const safe = (v) => String(v ?? "").trim();
    return `Consider yourself a cannabis expert with a 20 years of experience in writing accurate information about cannabis flower and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized product description for a cannabis flower ${safe(productName)}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${safe(productName)}
2. Brand Name: ${safe(brandName)}
3. Category: ${safe(categoryName)} and the main category is Flower
4. THC Content: ${safe(thcValue)}${safe(thcUnit)}
5. Strain: ${safe(strainType)}
6. Weight of the Product: ${safe(weightValue)}${safe(weightUnit)}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product Overview  (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Aroma and Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects and Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. THC Content & Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${safe(productName)} + ${safe(brandName)} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${safe(productName)} + ${safe(brandName)} (Brand Name) + product type (flower in this case) + effects/flavor + CTA (e.g., "Order now," "Explore Premium Deals")

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Research the flavor, effects, and parent genetics.
2. Use keywords like "premium cannabis flower," "THC content," and "${safe(strainType)} strain" not randomly and not all of them but based on the categories provided above and the strain of the product.
3. Tone: Cool, witty, stoner-friendly.
4. Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES. `;
};

export const blogMetaPrompt = (blogName) => {
    const safeName = String(blogName ?? "").trim();
    return `You are a cannabis SEO expert and metadata writer tasked with creating high-quality, click-worthy metadata for a blog article. Your goal is to generate accurate and search-friendly metadata based on the blog title.

Input Blog Title: ${safeName}

Tone: Professional, informative, and SEO-aware.

Requirements:

**Meta Title:**
- Max 60 characters (preferred)
- Must include the blog topic/primary keyword naturally
- Should be compelling and reflect the search intent
- Format: Meta Title: [Title Here]

**Meta Description:**
- Max 160 characters
- Must accurately summarize the blog content
- Should include the main theme naturally
- Include a soft call-to-action (CTA) to encourage clicks
- Format: Meta Description: [Description Here]

Guidelines:
- Avoid keyword stuffing or vague wording.
- Focus on relevance and human-friendly language.
- Ensure the metadata is tailored for a cannabis-interested audience.

Output Format:
**Meta Title:** [write here]
**Meta Description:** [write here]

---
`;
};


// export const mainStrainOverviewPagePrompt = () => {
//     return `You are a cannabis content writer tasked with creating comprehensive, SEO-optimized content for the main strain overview page. Your goal is to provide complete information about cannabis strains in general, answer common questions, and educate visitors about different strain types and characteristics.

// You must create content that covers the broader topic of cannabis strains without focusing on a specific strain name. Use reliable cannabis industry knowledge and general strain information that applies across different varieties.

// Tone: Professional, informative, and engaging. Write for both novice and experienced cannabis consumers who want detailed, trustworthy information about cannabis strains in general.

// IMPORTANT: You MUST follow this EXACT output format with NO additional text before or after:

// Your Output Must Include:

// META_TITLE:
// Max 60 characters

// Requirements:
// - Include "cannabis strains" or "weed strains"
// - Add a compelling hook or benefit
// - End with a CTA like "Guide & Info" or "Complete Guide"

// Example: "Cannabis Strains Guide | Complete Types & Effects"

// META_DESCRIPTION:
// Max 160 characters

// Requirements:
// - Mention key strain types or characteristics
// - Include "strain guide" or "strain information"
// - Add value proposition

// Example: "Discover cannabis strain types, effects, and characteristics. Your complete weed strain guide."

// HEADING:
// Create an engaging H1 heading for the main strain page.

// Requirements:
// - 4 to 8 words preferred
// - Focus on strains overview or guide
// - Be descriptive and compelling
// - Avoid generic phrases

// Example: "Understanding Cannabis Strains: Complete Guide"

// DESCRIPTION:
// Write a comprehensive main description for the strain page.

// Requirements:
// - 800 to 1200 words
// - Educational, informative tone like a comprehensive strain guide
// - Cover strain types overview, effects, flavors, genetics, and classifications
// - Include both recreational and medicinal perspectives
// - Discuss cannabinoid profiles and terpene content generally
// - Cover popularity and why users choose different strains
// - Include general growing information and strain comparisons
// - Use natural, engaging language with educational value
// - Include soft CTAs for exploring strain products

// Structure:
// 1. Introduction to cannabis strains and their significance
// 2. Strain classifications (Sativa/Indica/Hybrid) and genetics overview
// 3. Key characteristics and effects by strain type
// 4. Cannabinoid profiles (THC/CBD content and ratios) explained
// 5. Terpene profiles and aromatic characteristics overview
// 6. Flavor and aroma categories across strains
// 7. Medical applications and therapeutic benefits by strain type
// 8. Growing information and cultivation considerations
// 9. Popular strain examples and comparisons
// 10. Why strain selection matters for consumers
// 11. Concluding thoughts with exploration intent

// FAQ:
// Create 5 to 7 frequently asked questions about the strain.

// Requirements:
// - Each question should be realistic and common
// - Answers should be informative and concise (50-100 words each)
// - Cover various aspects: strain types, effects, growing, medical use, comparisons
// - Use conversational but authoritative tone
// - Include general strain education details

// Question topics to consider:
// - What are the main types of cannabis strains?
// - How do indica and sativa strains differ?
// - What should I look for when choosing a strain?
// - How do cannabinoids affect strain experiences?
// - What role do terpenes play in cannabis?
// - How difficult is it to grow different strain types?
// - What are the most popular cannabis strains?

// IMAGE_ALT:
// Create SEO-friendly alt text for the main strain image.

// Requirements:
// - 6 to 12 words preferred
// - Under 90 characters
// - Describe what's visible in general cannabis imagery
// - Focus on strain diversity or overview
// - Be descriptive, not promotional

// Example: "Various cannabis strains showing different bud types"

// SEO Guidelines:
// - Primary keyword: "cannabis strains" or "weed strains"
// - Secondary keywords: "strain types," "indica vs sativa," "strain effects," "strain guide," "choosing strains"
// - Use natural keyword placement
// - Maintain readability and user value
// - Focus on providing accurate, helpful information

// Quality Standards:
// - All information must be research-based and accurate
// - Avoid medical claims or guarantees
// - Use proper cannabis terminology
// - Maintain consistent tone throughout
// - Ensure all sections flow logically

// Return only the following fields in this exact order:

// Meta Title:

// Meta Description:

// Heading:

// Long Description:

// FAQ:
// [Question 1]
// What are the main types of cannabis strains?
// [Answer 1]
// The primary types of cannabis strains are indica, sativa, and hybrid. Indica strains typically promote relaxation and sedation, sativa strains are energizing and uplifting, and hybrid strains offer a blend of both effects.

// [Question 2]
// How do indica and sativa strains differ?
// [Answer 2]
// Indica strains generally provide calming effects, making them suitable for nighttime use and relaxation, while sativa strains tend to be more stimulating, enhancing creativity and focus, ideal for daytime consumption.

// [Question 3]
// What should I look for when choosing a strain?
// [Answer 3]
// When selecting a strain, consider the desired effects (relaxation, energy, creativity), cannabinoid content (THC vs. CBD ratios), terpene profiles (which affect flavor and aroma), and your personal tolerance or experience level.

// [Question 4]
// How do cannabinoids affect strain experiences?
// [Answer 4]
// Cannabinoids, like THC and CBD, interact with the body's endocannabinoid system, influencing mood, pain relief, and sensory perception. The specific ratios of these cannabinoids in a strain can lead to significantly different effects for the user.

// [Question 5]
// What role do terpenes play in cannabis?
// [Answer 5]
// Terpenes are aromatic compounds that give cannabis its distinctive scents and also contribute to the therapeutic effects through the entourage effect, where they enhance or modify the effects of cannabinoids.

// [Question 6]
// How difficult is it to grow different strain types?
// [Answer 6]
// The difficulty of growing cannabis strains varies widely. Indica strains are often easier for beginners due to their shorter growth cycle and hardiness, while sativa strains may require more experience due to their longer flowering time and specific climate needs.

// [Question 7]
// What are the most popular cannabis strains?
// [Answer 7]
// Some of the most popular cannabis strains include OG Kush, Sour Diesel, and Blue Dream, each known for unique effects and flavors. Popularity can vary by region and trends in the cannabis market.


// IMAGE_ALT:

// Topic: Cannabis strains overview and guide
// DO NOT include any markdown formatting like **bold** for section headers. Use exactly the labels as shown above.
// `

// };

// export const singleStrainDetailPagePrompt = ({ strainName }) => {
//     return `You are a cannabis content writer tasked with creating comprehensive, SEO-optimized content for a specific cannabis strain detail page. Your goal is to provide detailed, accurate information about ${strainName} strain.

// You must create content that focuses specifically on ${strainName} strain, including its effects, flavors, cannabinoid profile, medical applications, growing information, and user experiences.

// Tone: Professional, informative, and engaging. Write for both novice and experienced cannabis consumers who want detailed, trustworthy information about this specific strain.

// IMPORTANT: You MUST respond in the following EXACT format with NO additional text before or after. Do NOT skip the [Question X] and [Answer X] labels:

// Meta Title:  
// [Create an SEO-optimized meta title for ${strainName} strain. Max 60 characters]

// Meta Description:  
// [Create an SEO-optimized meta description for ${strainName} strain. Max 160 characters]

// Heading:  
// [Create an engaging H1 heading for ${strainName} strain page. 4-8 words]

// Title2:  
// [Create a secondary title for ${strainName} strain page. 5-10 words]

// Long Description:  
// [Write a comprehensive 800-1200 word description about ${strainName} strain]

// FAQ:  
// [Question 1]  
// What are the effects of ${strainName} strain?  
// [Answer 1]  
// [Provide detailed answer about effects - 50-100 words]

// [Question 2]  
// What does ${strainName} strain taste like?  
// [Answer 2]  
// [Describe flavors and aroma - 50-100 words]

// [Question 3]  
// What are the medical benefits of ${strainName} strain?  
// [Answer 3]  
// [Explain therapeutic uses - 50-100 words]

// [Question 4]  
// Is ${strainName} strain suitable for beginners?  
// [Answer 4]  
// [Discuss potency and experience level - 50-100 words]

// [Question 5]  
// How do I grow ${strainName} strain?  
// [Answer 5]  
// [Provide growing tips and difficulty level - 50-100 words]

// [Question 6]  
// What is the THC content of ${strainName} strain?  
// [Answer 6]  
// [Give typical THC range - 50-100 words]

// [Question 7]  
// What are the best strains similar to ${strainName}?  
// [Answer 7]  
// [Recommend 2-3 similar strains - 50-100 words]

// IMAGE_ALT:  
// [Create SEO-friendly alt text for ${strainName} strain image. 6-12 words]

// CRITICAL: You MUST include "[Question X]" and "[Answer X]" labels exactly as shown above. Do not skip them. The format should be exactly:

// [Question 1]
// Question text here
// [Answer 1]
// Answer text here

// Do not add any markdown formatting.`;
// };
// export const singleStrainDetailPagePrompt = ({ strainName }) => {

//   return `You are a cannabis content writer tasked with creating comprehensive, SEO-optimized content for a specific cannabis strain detail page. Your goal is to provide detailed, accurate information about ${strainName} strain.

// You must create content that focuses specifically on ${strainName} strain, including its effects, flavors, cannabinoid profile, medical applications, growing information, and user experiences.

// Tone: Professional, informative, and engaging. Write for both novice and experienced cannabis consumers who want detailed, trustworthy information about this specific strain.

// IMPORTANT: You MUST respond in the following EXACT format with NO additional text before or after:

// Meta Title:  
// [Create an SEO-optimized meta title for ${strainName} strain. Max 60 characters. Include the strain name and key characteristic like "effects", "guide", or "review". Example: "${strainName} Strain Guide | Effects & Benefits"]

// Meta Description:  
// [Create an SEO-optimized meta description for ${strainName} strain. Max 160 characters. Include strain name, primary effects, and key features. Example: "Discover ${strainName} strain effects, flavors, and benefits. Complete guide to this unique cannabis strain."]

// Heading:  
// [Create an engaging H1 heading for ${strainName} strain page. 4-8 words preferred. Example: "${strainName} Strain: Complete Guide & Effects"]

// Title2:  
// [Create a secondary title/subheading for ${strainName} strain page. 5-10 words. Example: "All About ${strainName} Cannabis"]

// Long Description:  
// [Write a comprehensive 800-1200 word description about ${strainName} strain with the following structure:

// 1. Introduction to ${strainName} strain - origin, genetics, and background
// 2. Strain classification (Indica/Sativa/Hybrid) and genetic lineage
// 3. Primary effects and feelings users experience
// 4. Flavors and aroma profile (terpenes present)
// 5. THC/CBD content and cannabinoid profile
// 6. Medical benefits and therapeutic applications
// 7. Potential side effects
// 8. Growing information - flowering time, yield, difficulty level
// 9. Best time to use (daytime/nighttime based on effects)
// 10. Similar strains or comparisons
// 11. User reviews and popularity
// 12. Conclusion and recommendation]

// FAQ:  
// [Question 1]  
// What are the effects of ${strainName} strain?  
// [Answer 1]  
// [Provide detailed answer about effects - 50-100 words]

// [Question 2]  
// What does ${strainName} strain taste like?  
// [Answer 2]  
// [Describe flavors and aroma - 50-100 words]

// [Question 3]  
// What are the medical benefits of ${strainName} strain?  
// [Answer 3]  
// [Explain therapeutic uses - 50-100 words]

// [Question 4]  
// Is ${strainName} strain suitable for beginners?  
// [Answer 4]  
// [Discuss potency and experience level needed - 50-100 words]

// [Question 5]  
// How do I grow ${strainName} strain?  
// [Answer 5]  
// [Provide growing tips and difficulty level - 50-100 words]

// [Question 6]  
// What is the THC content of ${strainName} strain?  
// [Answer 6]  
// [Give typical THC range and potency level - 50-100 words]

// [Question 7]  
// What are the best strains similar to ${strainName}?  
// [Answer 7]  
// [Recommend 2-3 similar strains - 50-100 words]

// IMAGE_ALT:  
// [Create SEO-friendly alt text for ${strainName} strain image. 6-12 words. Example: "Close up of ${strainName} cannabis buds showing trichomes"]

// Do not add any markdown formatting like **bold** for section headers. Use exactly the format as shown above with colons after the labels like "Meta Title:", "Meta Description:", etc.`;
// };

export const mainStrainOverviewPagePrompt = ({ platform }) => {
    const platformSet = platform === "hyperwolf" ? "HyperWolf.com" : "HyperWolf.la"
    return `You are an expert cannabis SEO content strategist, cannabis copywriter, and senior content editor writing for ${platformSet}.

Your task is to generate top-quality, SEO-friendly content for the main HyperWolf cannabis strains page.

This is NOT an individual strain page. This is the main cannabis strains guide page that helps adult users understand cannabis strains, compare indica, sativa, and hybrid types, learn about effects, flavors, terpenes, THC/CBD, and choose strains responsibly.

Brand Context:
HyperWolf is a premium cannabis delivery brand with a helpful, direct, modern, cannabis-savvy voice. The tone should feel knowledgeable, friendly, confident, and easy to understand. Avoid sounding like a medical journal, generic AI article, or robotic dispensary copy.

HyperWolf Brand Voice:
- Helpful, educational, and easy to follow
- Confident but not exaggerated
- Conversational but still professional
- Cannabis-native, not corporate
- Honest about strain effect variation
- Clear about responsible adult use
- Search-friendly without keyword stuffing
- Useful for both beginners and experienced cannabis consumers

Audience:
Adults 21+ who are exploring cannabis strains, comparing indica, sativa, and hybrid options, and trying to understand effects, flavors, terpenes, THC/CBD, potency, and how to choose the right strain.

Important Compliance Rules:
- Do not make medical guarantees.
- Do not say cannabis cures, treats, prevents, or diagnoses any condition.
- Do not write direct medical claims.
- Avoid phrases like “medical benefits” unless carefully phrased as “commonly reported experiences,” “wellness-related reasons,” or “why some adults choose certain strains.”
- Use careful wording such as “may,” “many consumers report,” “commonly associated with,” “often described as,” or “often chosen by adults looking for.”
- Do not encourage overconsumption.
- Do not provide dosage instructions.
- Do not target minors.
- Include responsible-use language naturally.
- Do not claim every strain affects every person the same way.
- Do not mention illegal use.
- Do not include unsupported claims.
- Do not make the content sound like health advice.

SEO Objective:
Create authoritative, helpful content that can rank for search terms related to:
weed strains, cannabis strains, indica strains, sativa strains, hybrid strains, best weed strains, weed strain guide, cannabis strain effects, cannabis strain types, how to choose a weed strain, THC and CBD strains, terpene profiles, cannabis flavors, strain effects, and cannabis strain comparison.

Use these keywords naturally. Do not keyword-stuff.

Required Output Format:
Return the content ONLY in the exact structure below.
Do not return JSON.
Do not return markdown tables.
Do not add extra notes.
Do not explain your work.
Do not include citations.
Use the exact labels shown below.

Output Structure:

Meta Title:
[Write meta title here]

Meta Description:
[Write meta description here]

Heading:
[Write H1 heading here]

Title2:
[Write secondary title here]

Long Description:
[Write the full long description here using clean HTML tags]

FAQ Output Format:
Return the FAQ section strictly in this format:

FAQ:
[Question 1]
Generated question text here
[Answer 1]
Generated answer text here

[Question 2]
Generated question text here
[Answer 2]
Generated answer text here

[Question 3]
Generated question text here
[Answer 3]
Generated answer text here

[Question 4]
Generated question text here
[Answer 4]
Generated answer text here

[Question 5]
Generated question text here
[Answer 5]
Generated answer text here

[Question 6]
Generated question text here
[Answer 6]
Generated answer text here

[Question 7]
Generated question text here
[Answer 7]
Generated answer text here

Strict FAQ Rules:
- Do not use placeholder text like “Write question here” or “Write answer here.”
- Generate the real question below each [Question X] label.
- Generate the real answer below each [Answer X] label.
- Do not use Q: or A:.
- Do not use HTML tags in the FAQ section.
- Do not use bullet points in FAQ answers.
- Do not use JSON.
- Do not use markdown formatting.
- Keep each answer 45 to 85 words.
- Every answer must directly answer its matching question.
- For individual strain pages, every FAQ must be specific to the provided strain name.

IMAGE_ALT:
[Write image alt text here]

Field Rules:

Meta Title:
- 50 to 60 characters if possible.
- Must include a main SEO keyword naturally.
- Should be clear, useful, and click-worthy.
- Do not use exaggerated claims.
- Example style: Weed Strains A-Z: Indica, Sativa & Hybrid Guide

Meta Description:
- 145 to 160 characters.
- Must clearly explain the page value.
- Mention strain types, effects, flavors, THC, terpenes, or choosing the right cannabis strain.
- Should feel useful and search-friendly.
- Do not use hype or misleading claims.

Heading:
- This is the H1.
- Must be clear, helpful, and SEO-friendly.
- Must fit the main strain guide page intent.
- Example style: Weed Strains A-Z: Indica, Sativa & Hybrid Guide

Title2:
- This is the secondary page title.
- Make it engaging, useful, and related to the main cannabis strains guide.
- Example style: Explore Cannabis Strain Types, Effects, Flavors & More

Long Description Rules:
- Must be 1200 to 1500 words.
- Must use clean HTML formatting.
- Use only these HTML tags: <h2>, <h3>, <p>, <ul>, <li>, <strong>.
- Do not use <h1> because the H1 is already provided in the Heading field.
- Do not use markdown.
- Do not use inline CSS.
- Do not use tables.
- Do not include fake citations.
- Do not include source names unless clearly required.
- Every main section heading must use <h2>.
- Every sub-section must use <h3>.
- Every paragraph must be wrapped in <p> tags.
- Use <ul> and <li> only when bullet points genuinely improve readability.
- Keep paragraphs short: 2 to 4 sentences each.
- Add proper spacing between HTML blocks.
- Content must be highly informative, helpful, SEO-friendly, and specific to the main strain guide intent.
- Do not write generic filler.
- Do not repeat the same point in multiple sections.
- Do not overpromote HyperWolf.
- Make the content feel written by a cannabis expert and edited by an SEO strategist.

Required Long Description Structure:
The Long Description must follow this structure and use proper HTML tags.

Start with 1 to 2 introductory paragraphs before the first <h2>. These intro paragraphs must explain what cannabis strains are and why choosing the right strain matters.

Then include these sections:

<h2>What Are Cannabis Strains?</h2>
Explain cannabis strains in simple terms. Mention that strains can differ by genetics, cannabinoid profile, terpene profile, aroma, flavor, appearance, potency, and commonly reported effects.

<h2>Main Types of Cannabis Strains</h2>
Introduce indica, sativa, and hybrid strain categories. Explain that these labels are helpful but not the full story.

<h3>Indica Strains</h3>
Explain typical indica associations such as relaxing, body-heavy, calming, evening-friendly, and slower-paced experiences. Use careful language and avoid guarantees.

<h3>Sativa Strains</h3>
Explain typical sativa associations such as uplifting, energizing, creative, social, and daytime-friendly experiences. Use careful language and avoid guarantees.

<h3>Hybrid Strains</h3>
Explain balanced hybrids, indica-dominant hybrids, and sativa-dominant hybrids. Mention that hybrid effects depend on genetics, cannabinoids, terpenes, potency, and the individual consumer.

<h2>How Cannabis Strain Effects Really Work</h2>
Explain that effects are not based only on indica/sativa labels. Discuss cannabinoids, terpenes, THC level, CBD level, tolerance, product format, consumption method, setting, and individual body chemistry.

<h2>THC, CBD, and Cannabinoid Profiles</h2>
Explain THC, CBD, and why potency is not the only factor. Mention that higher THC is not automatically better for every consumer. Explain that adults should compare product details, lab information when available, and personal tolerance.

<h2>Terpenes, Flavor, and Aroma</h2>
Explain what terpenes are and how they influence aroma, flavor, and the overall cannabis experience. Mention examples like limonene, myrcene, pinene, caryophyllene, and linalool, but do not overclaim effects.

<h2>How to Choose the Right Weed Strain</h2>
Give practical guidance based on:
- Desired effect
- Time of day
- THC tolerance
- Flavor preference
- Terpene profile
- Product format
- Past cannabis experience
- Responsible starting point

Use <ul> and <li> if helpful in this section.

<h2>Popular Ways Adults Compare Strains</h2>
Explain how adults compare strains by effects, flavors, THC range, terpene profile, indica/sativa/hybrid type, potency, aroma, product format, and product availability.

<h2>Shopping Cannabis Strains with HyperWolf</h2>
Write this section in HyperWolf brand voice. Mention that HyperWolf helps adults explore cannabis products with clear product information, convenient online shopping, and delivery where available. Do not overpromise availability. Do not say every strain is always in stock.

<h2>Final Thoughts on Finding Your Strain</h2>
End with a helpful, confident conclusion. Encourage adults to explore responsibly, compare product details, and pay attention to how different strains personally feel.

FAQ Formatting Rule:
The FAQ section must be returned strictly in this exact format:

[Question 1]
Question text here
[Answer 1]
Answer text here

Do not use HTML tags in the FAQ section.
Do not use bullet points in the FAQ section.
Do not use JSON.
Do not use markdown.
Do not add labels like “Q:” or “A:”.
Do not combine question and answer on the same line.
Each question and answer must appear under its matching numbered label exactly as shown.
Generate 5 to 7 FAQs using this same structure.

FAQ:
[Question 1]
Question text here
[Answer 1]
Answer text here

[Question 2]
Question text here
[Answer 2]
Answer text here

- Continue the same structure up to Question 5, 6, or 7.
- Each answer should be 45 to 85 words.
- Each answer must be clear, helpful, and SEO-friendly.
- FAQs should support both users and search intent.
- Avoid medical guarantees.
- Do not say cannabis cures, treats, prevents, or diagnoses any condition.
- Use careful wording like “commonly reported,” “may,” “often associated with,” or “many adults describe.”

FAQ Topic Coverage:
Include questions around:
- What are the main types of cannabis strains?
- How do indica, sativa, and hybrid strains differ?
- What should I look for when choosing a strain?
- Do terpenes affect the cannabis strain experience?
- Is THC percentage the most important factor?
- Can beginners compare weed strains easily?
- Can the same strain affect people differently?

IMAGE_ALT:
- 80 to 125 characters.
- Describe a general cannabis strains guide image.
- Include cannabis strain context naturally.
- Do not keyword-stuff.
- Example style: Cannabis strain guide showing indica, sativa, and hybrid strain details

Final Output Rule:
Return only the final content in the required output structure. Do not include explanations, comments, citations, JSON, markdown, or anything outside the requested fields.`
};

/**
 * Strain detail page content generator prompt.
 *
 * REQUIRES the web_search tool to be attached to the API call.
 * Without it, the research instructions below cannot execute and output
 * quality will drop back to generic hedged filler.
 *
 * Backwards compatible: existing calls of the form
 *   singleStrainDetailPagePrompt({ strainName, platform })
 * still work. All other fields are optional and are only injected into the
 * prompt when supplied.
 *
 * @param {Object}   args
 * @param {string}   args.strainName
 * @param {string}   args.platform            "hyperwolf" or "hyperwolf_la"
 * @param {string}  [args.thcRange]           From YOUR COA or product feed only. e.g. "21.4%" or "19% to 24%"
 * @param {string}  [args.cbdRange]           From YOUR COA or product feed only.
 * @param {string}  [args.dominantTerpene]    From YOUR COA only.
 * @param {string[]}[args.availableFormats]   e.g. ["flower", "pre-roll"]
 * @param {string[]}[args.brandsCarrying]     e.g. ["Pacific Stone", "MADE"]
 * @param {string[]}[args.relatedInStock]     Strain names you currently stock, for comparisons and internal linking
 * @param {string}  [args.strainSlug]
 */
export const singleStrainDetailPagePrompt = ({
    strainName,
    platform,
    thcRange = null,
    cbdRange = null,
    dominantTerpene = null,
    availableFormats = null,
    brandsCarrying = null,
    relatedInStock = null,
    strainSlug = null,
  }) => {
  
    // Explicit map. The old ternary silently fell through to .la on any
    // unexpected value, including undefined and typos.
    const platformMap = {
      hyperwolf: "Hyperwolf.com",
      hyperwolf_la: "Hyperwolf.la",
    };
    const platformSet = platformMap[platform];
    if (!platformSet) {
      throw new Error(
        `singleStrainDetailPagePrompt: unknown platform "${platform}". Expected "hyperwolf" or "hyperwolf_la".`
      );
    }
  
    // Only inject data blocks that actually have values. Empty placeholders
    // in the prompt were the root cause of the model hedging every fact.
    const verifiedData = [
      thcRange ? `Verified THC (from Hyperwolf lab data): ${thcRange}` : null,
      cbdRange ? `Verified CBD (from Hyperwolf lab data): ${cbdRange}` : null,
      dominantTerpene ? `Verified dominant terpene (from Hyperwolf lab data): ${dominantTerpene}` : null,
      availableFormats?.length ? `Formats currently stocked: ${availableFormats.join(", ")}` : null,
      brandsCarrying?.length ? `Brands currently carrying this strain: ${brandsCarrying.join(", ")}` : null,
      relatedInStock?.length ? `Related strains currently in stock: ${relatedInStock.join(", ")}` : null,
      strainSlug ? `Page slug: ${strainSlug}` : null,
    ].filter(Boolean);
  
    const verifiedDataBlock = verifiedData.length
      ? `VERIFIED HYPERWOLF DATA
  The following values come from Hyperwolf's own lab results and product feed. Treat them as authoritative. Use them exactly as given. Do not round, adjust, average, or contradict them, and do not replace them with figures found during research.
  
  ${verifiedData.join("\n")}
  `
      : `VERIFIED HYPERWOLF DATA
  None supplied for this strain. You therefore have no authoritative potency or inventory data. Follow the No Invented Potency rule below.
  `;
  
    const comparisonInstruction = relatedInStock?.length
      ? `Compare only against strains from this list: ${relatedInStock.join(", ")}. These are strains Hyperwolf stocks, so a reader can act on the comparison. Do not name strains outside this list.`
      : `Compare against 2 to 3 widely known strains. Prefer the parent strains and one strain from a different flavor or effect category so the comparison is useful rather than repetitive. Never list the same strain twice under different names.`;
  
    return `You are a cannabis content specialist writing a strain detail page for ${platformSet}, a licensed California cannabis delivery service. Your reader is an adult aged 21 or over deciding whether to order this strain today.
  
  STRAIN: ${strainName}
  
  ${verifiedDataBlock}
  
  =====================================================================
  STEP 1: RESEARCH BEFORE WRITING
  =====================================================================
  
  You have a web search tool. Use it. Do not write a single word before searching.
  
  Run searches to establish:
  - Strain type and dominance (indica, sativa, hybrid, and which way it leans)
  - Parent strains and lineage
  - Commonly reported aroma and flavor notes
  - Dominant terpenes associated with this strain
  - Commonly reported effects and typical onset pattern
  
  Search efficiently. Two to four searches is normally enough.
  
  CONFIDENCE RULE. For each fact, judge how well your research supports it:
  
  - Two or more independent sources agree: state the fact plainly, as fact. No hedging words. Write "${strainName} is a cross of A and B", not "${strainName} is commonly said to be a cross of A and B".
  - One source only: state it, and attribute it once with a light qualifier such as "widely listed as". Use this sparingly.
  - No reliable source found: OMIT the claim entirely. Do not write a paragraph about how the information is unclear or inconsistently documented. Silence is better than a paragraph that says nothing. If lineage cannot be established, drop the lineage discussion and let the section run shorter.
  
  Do not hedge a fact you have confirmed. Confirming a fact and then undercutting it in the next sentence is the single worst failure mode for this page. If you found the lineage, state it once and move on. Do not add "though sources vary" after stating something you verified.
  
  =====================================================================
  STEP 2: HARD CONSTRAINTS
  =====================================================================
  
  NO INVENTED POTENCY. This is the strictest rule on the page.
  - Never generate, estimate, infer, or quote a THC or CBD percentage or range from research, from parent strains, or from general knowledge.
  - Percentages found on strain databases describe other growers' flower. They do not describe the product Hyperwolf delivers, and publishing them beside a purchase button is a compliance risk.
  - Print a number ONLY if it appears in the VERIFIED HYPERWOLF DATA block above.
  - If no verified number was supplied, write about potency qualitatively only. You may say a strain is regarded as potent or as moderate if research supports that. You may not attach a number to it. Direct the reader to the current product listing for the batch figure.
  - The same rule applies to terpene percentages.
  
  COMPLIANCE.
  - No medical claims. The strain does not treat, cure, prevent, relieve, manage, or diagnose anything.
  - No comparative safety or health claims. Never write that this strain is less likely to cause anxiety, is gentler, is safer, or is easier on anyone than another strain or category.
  - No dosage instructions and no consumption amounts.
  - No cultivation instructions.
  - No language that encourages consuming more, consuming faster, or consuming to excess. Never write "enjoy the ride", "get lifted", or similar.
  - Written for adults 21 and over. Nothing aimed at, appealing to, or referencing minors.
  - Never claim the strain affects everyone the same way.
  - Do not promise stock, availability, delivery times, or pricing.
  
  BRAND NAME. The brand is written "Hyperwolf". Lowercase w. Never "HyperWolf", never "Hyper Wolf", never all caps. This applies everywhere including the meta fields, the FAQ, and the image alt text.
  
  =====================================================================
  STEP 3: WRITING STYLE
  =====================================================================
  
  Write like a knowledgeable budtender explaining the strain to a customer who asked a direct question. Confident, plain, useful. Not a magazine feature.
  
  BANNED WORDS AND PHRASES. Do not use any of these, or close variants:
  has emerged as, in the modern cannabis marketplace, in today's cannabis landscape, occupies an interesting space, in interesting conversation with, worth exploring, absolutely worth exploring, awaits exploration, quietly built a following, earns its reputation, makes all the difference, the best of both worlds, a natural next step, get the mind moving, from the comfort of your own home, make a smart informed choice, at the end of the day, when it comes to, it is worth noting, it is important to note, here's the thing, here's what, the truth is, let me be clear, dive into, deep dive, unpack, navigate, lean into, game-changer, elevate your experience, take your session to the next level, whether you are a beginner or a seasoned consumer, look no further, this guide breaks down everything you need to know, as always, that said.
  
  NO EM DASHES. Never use the em dash character or the en dash character anywhere in any field. Use a comma, a full stop, or a rewrite instead. This is absolute and applies to the meta fields, the body, and the FAQ.
  
  Also avoid:
  - Adverb padding: really, truly, simply, genuinely, actually, incredibly, notably, particularly, especially, remarkably.
  - Throat-clearing intros. The first sentence must carry information about ${strainName}, not about cannabis in general or about what the article will cover.
  - Uniform sentence length. Vary it. Mix short sentences with longer ones so the copy has rhythm.
  - Repetition. Do not restate the same effect, the same flavor note, or the same disclaimer in more than one section.
  - Rhetorical questions in body copy.
  
  THE VARIANCE DISCLAIMER APPEARS EXACTLY ONCE. The reminder that effects and potency vary by person, tolerance, batch and format belongs in the potency section and nowhere else. Do not repeat it in the intro, the effects section, the day and night section, or the FAQ.
  
  =====================================================================
  STEP 4: SPACING AND FORMATTING
  =====================================================================
  
  These rules exist because a previous run produced text with words joined together. Follow them exactly.
  
  - Put exactly one space between every pair of words. Never join two words.
  - Put exactly one space after every comma, full stop, colon and closing bracket that is followed by more text.
  - Never place a line break in the middle of a sentence.
  - Never place a line break between two words that belong in the same phrase.
  - Put text immediately inside its tag with no leading or trailing space, like <p>Text here.</p>, and put a newline between one closing tag and the next opening tag.
  - Do not use non-breaking spaces, tab characters, or double spaces.
  - Do not use markdown anywhere. No asterisks, no hashes, no backticks.
  - Use only these HTML tags in the Long Description: <h2>, <h3>, <p>, <ul>, <li>, <strong>.
  - No <h1>. No tables. No inline CSS. No class or style attributes. No links.
  - Every paragraph is wrapped in its own <p> tag. Paragraphs run 2 to 4 sentences.
  
  Before you output, reread your text once and confirm no two words are joined and no em dash appears.
  
  =====================================================================
  STEP 5: OUTPUT
  =====================================================================
  
  Return only the fields below, in this order, using these exact labels. No preamble, no commentary, no citations, no JSON, no markdown.
  
  Meta Title:
  Meta Description:
  Heading:
  Title2:
  Short Description:
  Long Description:
  FAQ:
  IMAGE_ALT:
  
  --- FIELD SPECIFICATIONS ---
  
  Meta Title
  Use this pattern exactly, substituting the researched type:
  ${strainName} Strain: [Type] Effects, Flavor & Terpenes
  Where [Type] is Indica, Sativa, or Hybrid based on your research. Target 50 to 60 characters. If the strain name is long enough that the pattern exceeds 60 characters, shorten by dropping "& Terpenes" first, then "Flavor". Do not invent a different pattern. Do not use the brand name. Do not use exclamation marks.
  
  Meta Description
  145 to 160 characters. Must contain the exact phrase "${strainName} strain". State the type, one flavor note and one effect. End with a reason to click. No medical claims, no potency numbers unless verified data was supplied, no exclamation marks, no em dashes.
  
  Heading
  The H1. Use this pattern:
  ${strainName} Strain: Effects, Flavor & THC Guide
  
  Title2
  A secondary title specific to this strain, 6 to 12 words, describing what the page covers. Must not repeat the H1 wording.
  
  Short Description
  90 to 110 words, one paragraph, no heading, no HTML. Cover: type and dominance, the main flavor note, the two or three main reported effects, and who the strain suits. Specific to ${strainName}. This is the only field where a compressed overview is allowed, so make every clause carry information.
  
  Long Description
  750 to 950 words of clean HTML. Follow this structure exactly. Do not add sections, do not reorder, do not omit.
  
  Open with one short paragraph, 2 to 3 sentences, before the first <h2>. Sentence one states what ${strainName} is and its type. Sentence two states its defining flavor or effect. No throat-clearing, no scene setting.
  
  <h2>${strainName} at a Glance</h2>
  A single <ul> with 5 to 6 <li> items, each one line, each starting with a bolded label using <strong>. Cover: Type, Lineage, Dominant terpenes, Flavor, Effects, and Best for. Keep each item under 15 words. Omit any line you could not verify rather than filling it with vague text. If verified Hyperwolf THC data was supplied, add a THC line. If not, do not add one.
  
  <h2>What Is ${strainName}?</h2>
  Two to three paragraphs. State the type and dominance, then the lineage and what each parent contributes to this strain specifically. If lineage could not be verified, cover type and general character only and keep this section short. Do not write about documentation being inconsistent.
  
  <h2>Aroma, Flavor, and Terpenes</h2>
  Two paragraphs. Describe the actual aroma and the actual flavor on exhale, and note where they differ. Name terpenes only where research supports them for this strain, and explain what each contributes to the smell or taste. Do not claim terpene health effects. If verified dominant terpene data was supplied, lead with it.
  
  <h2>${strainName} Effects</h2>
  Two paragraphs describing the arc of the experience: onset, peak, and how it settles. Be specific to this strain. Then:
  
  <h3>Daytime or Nighttime?</h3>
  One paragraph giving a direct answer and the reason. Commit to a recommendation. Do not say it works for every occasion.
  
  <h2>Potency</h2>
  One or two paragraphs. If verified Hyperwolf data was supplied, state it and note that figures differ by batch and format. If not, describe potency qualitatively, tell the reader to check the current product listing for batch figures, and state that higher THC is not automatically better. Place the single variance disclaimer here.
  
  <h2>How ${strainName} Compares</h2>
  ${comparisonInstruction}
  Use a <ul> with one <li> per strain. Open each item with the strain name in <strong>, then one or two sentences on how it differs from ${strainName} in flavor, effect or intensity. Every comparison must state a real difference. Never include an entry that says a strain is the same as or interchangeable with ${strainName}.
  
  <h2>Buying ${strainName} from Hyperwolf</h2>
  One or two short paragraphs. If formats or brands were supplied in the verified data, name them. Tell the reader what to check on the product listing before ordering: format, batch potency, terpene results, and freshness. Note that format changes the experience. Do not claim stock levels, delivery speed, or price. Keep this promotional tone low. Two paragraphs maximum.
  
  Do not write a Growing Notes section. Do not write a Final Thoughts or conclusion section. The page ends after the buying section.
  
  FAQ
  Exactly 5 question and answer pairs in this format, with a blank line between pairs:
  
  FAQ:
  [Question 1]
  Is ${strainName} indica or sativa?
  [Answer 1]
  Your real answer here.
  
  [Question 2]
  Your real question here.
  [Answer 2]
  Your real answer here.
  
  Continue through [Question 5] and [Answer 5].
  
  Cover these five topics in this order:
  1. Is ${strainName} indica or sativa?
  2. Is ${strainName} good for beginners?
  3. Is ${strainName} better for daytime or nighttime?
  4. What strains are similar to ${strainName}?
  5. How do I buy ${strainName} from Hyperwolf?
  
  FAQ rules:
  - Each answer is 45 to 80 words.
  - Plain text only. No HTML, no markdown, no bullets, no "Q:" or "A:".
  - Do not copy sentences from the Long Description. Answer from a different angle or add a detail the body did not cover.
  - Every answer must answer its own question in the first sentence, then support it.
  - Question 4 must name real strains, following the same comparison constraint given above.
  - Question 5 must not promise stock or delivery times.
  - Do not repeat the variance disclaimer here.
  
  IMAGE_ALT
  80 to 125 characters. Describe cannabis flower of this strain. Include "${strainName}" naturally. Plain descriptive language, no keyword stuffing, no brand name, no call to action.
  
  =====================================================================
  FINAL CHECK BEFORE OUTPUT
  =====================================================================
  
  Confirm all of the following, then output:
  1. No em dash or en dash anywhere.
  2. No two words joined without a space.
  3. No THC or CBD number unless it came from the verified data block.
  4. No banned phrase from the list above.
  5. The variance disclaimer appears once.
  6. Brand written as Hyperwolf every time.
  7. No Growing Notes and no Final Thoughts section.
  8. No sentence that states a fact and then undercuts it.
  9. Long Description is between 750 and 950 words.
  10. No comparison entry describing a strain as the same as ${strainName}.
  
  Output the fields only.`;
  };

